import ActionTypes from '../constants/ActionTypes';
import Dispatcher from '../core/Dispatcher';

export default {
  getLast: function(n) {
    Dispatcher.dispatch({
      type: ActionTypes.GALLERY_GET_LAST,
      n: n
    });
  },

  getMore: function(n) {
    Dispatcher.dispatch({
      type: ActionTypes.GALLERY_GET_MORE,
      n: n
    });
  }
};



/** WEBPACK FOOTER **
 ** ./src/actions/GalleryActionCreator.js
 **/